import { create } from 'zustand';

import { PlanFrequency, Service } from '@app-types/service.type';
import { subscriptionsSDK } from '@services/subscriptions';

type State = {
    services: Service[];
    planFrequencies: PlanFrequency[];

    fetchServices: () => Promise<void>;
    fetchFrequencies: () => Promise<void>;
};

export const useServicesStore = create<State>((set) => ({
    services: [],
    planFrequencies: [],

    fetchServices: async () => {
        const services = await subscriptionsSDK.admin.services.getAll();
        set({ services });
    },

    fetchFrequencies: async () => {
        const frequencies = await subscriptionsSDK.admin.frequencies.getAll();
        set({ planFrequencies: frequencies });
    },
}));
